import { useNavigate } from 'react-router-dom';

/**
 * "About Page" admin tab: unlike Service Pages there's only ever one About
 * page (a singleton, not a list), so this tab is just an index card linking
 * to the dedicated full-viewport WYSIWYG route (see ../AboutPageEditor.jsx).
 */
export default function AboutPageEditorTab() {
  const navigate = useNavigate();

  return (
    <div className="admin-panel">
      <div className="admin-panel__head">
        <div>
          <h2>About Page</h2>
          <p className="admin-panel__desc">
            The fully inline-editable <strong>/about</strong> page (hero, stats, mission/vision/approach,
            working-with-us, how-we-work, final CTA). Use <strong>Edit</strong> for on-page WYSIWYG editing.
          </p>
        </div>
      </div>

      <div className="admin-list">
        <div className="admin-list-item">
          <div>
            <strong>About Us</strong>
            <br />
            <a href="/about" target="_blank" rel="noopener noreferrer">
              /about
            </a>
          </div>
          <div className="admin-list-actions">
            <button
              type="button"
              className="admin-btn admin-btn--ghost admin-btn--sm"
              onClick={() => navigate('/admin/about-page/edit')}
            >
              Edit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
